import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "profile" }
const _hoisted_2 = { class: "flex flex-col p-2 mx-2" }
const _hoisted_3 = { class: "w-full flex flex-col mb-3 items-center" }
const _hoisted_4 = { class: "flex w-full flex-col" }
const _hoisted_5 = { class: "self-end text-sm" }
const _hoisted_6 = { class: "self-start text-sm" }
const _hoisted_7 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_8 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_9 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_10 = { class: "flex w-full flex-col" }
const _hoisted_11 = { class: "self-start text-sm" }
const _hoisted_12 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_13 = { class: "flex flex-col gap-3" }
const _hoisted_14 = { class: "w-full flex items-center justify-center" }
const _hoisted_15 = { class: "w-full flex items-center justify-center" }
const _hoisted_16 = { class: "w-full flex items-center justify-center" }

import DbButton from "@/components/DB-Components/DbButton.vue";
import DbInput from "@/components/DB-Components/DbInput.vue";
import { UserData } from "@/data/interfaces/UserDataInterface";
import { reAuthorize } from "@/services/auth/re-auth";
import store from "@/store";
import router from "@/router";
import { onMounted, ref } from "vue";
import {
  isFieldRequired,
  isFieldValid,
  validationMessage,
} from "@/utils/users/methods";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

const user = ref({
  username: "",
  first_name: "",
  last_name: "",
  phone_number: "",
});

const form = ref({
  errors: {},
  processing: false,
});

onMounted(() => {
  reAuthorize(store).then((res) => {
    store
      .dispatch("UserStore/getUser", store.state.user.data.user_id)
      .then((response) => {
        user.value = store.state.UserStore.user as UserData;
      });
  });
});

const update = async () => {
  form.value.processing = true;
  if (!isFormValid()) {
    return;
  }
  await store
    .dispatch("UserStore/editUser", user.value)
    .then((res) => {
      router.push("/");
    })
    .catch((error) => {
      const data = error?.response?.data;
      const errorStatus = data?.httpCode;
      if (errorStatus == 403) {
        form.value.errors = data.httpMessage;
      }
    });
};

const isFormValid = () => {
  let isFilled = true;
  // Check validity of all fields
  const allFieldsValid = Object.keys(user.value).every((fieldName) =>
    isFieldValid(fieldName, user.value)
  );
  if (!allFieldsValid) return false;

  if (form.value.processing == false) {
    isFilled =
      Object.keys(user.value).filter(
        (fieldName) =>
          isFieldRequired(fieldName) &&
          (user.value[fieldName] == null || user.value[fieldName]?.length == 0)
      ).length > 0
        ? false
        : true;
    return isFilled;
  }
  return true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("account.required")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("account.username_dispatcher_message")), 1)
        ]),
        _createVNode(DbInput, {
          disabled: true,
          modelValue: user.value.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((user.value.username) = $event)),
          value: user.value.username,
          placeholder: _ctx.$t('account.username'),
          label: _ctx.$t('account.username'),
          class: "w-full hydrated"
        }, null, 8, ["modelValue", "value", "placeholder", "label"]),
        (!_unref(isFieldValid)('username', user.value) && form.value.processing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("account.validation.username")), 1))
          : _createCommentVNode("", true)
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "mb-3" }, null, -1)),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full flex flex-col items-center", {
          'pb-6': !form.value.processing || _unref(isFieldValid)('first_name', user.value),
          'pb-0': !_unref(isFieldValid)('first_name', user.value) && form.value.processing,
        }])
      }, [
        _createVNode(DbInput, {
          modelValue: user.value.first_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((user.value.first_name) = $event)),
          value: user.value.first_name,
          class: _normalizeClass([{
            'border-red-500':
              !_unref(isFieldValid)('first_name', user.value) && form.value.processing,
          }, "w-full hydrated"]),
          placeholder: _ctx.$t('account.first_name'),
          label: _ctx.$t('account.first_name'),
          ariainvalid: 
            !_unref(isFieldValid)('first_name', user.value) && form.value.processing ? 'true' : ''
          
        }, null, 8, ["modelValue", "value", "class", "placeholder", "label", "ariainvalid"]),
        (!_unref(isFieldValid)('first_name', user.value) && form.value.processing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t("account.validation.first_name")), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full flex flex-col items-center", {
          'pb-6': !form.value.processing || _unref(isFieldValid)('last_name', user.value),
          'pb-0': !_unref(isFieldValid)('last_name', user.value) && form.value.processing,
        }])
      }, [
        _createVNode(DbInput, {
          modelValue: user.value.last_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.last_name) = $event)),
          value: user.value.last_name,
          class: _normalizeClass([{
            'border-red-500':
              !_unref(isFieldValid)('last_name', user.value) && form.value.processing,
          }, "w-full hydrated"]),
          placeholder: _ctx.$t('account.last_name'),
          label: _ctx.$t('account.last_name'),
          ariainvalid: 
            !_unref(isFieldValid)('last_name', user.value) && form.value.processing ? 'true' : ''
          
        }, null, 8, ["modelValue", "value", "class", "placeholder", "label", "ariainvalid"]),
        (!_unref(isFieldValid)('last_name', user.value) && form.value.processing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("account.validation.last_name")), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["w-full flex flex-col items-center", {
          'pb-6': !form.value.processing || _unref(isFieldValid)('phone_number', user.value),
          'pb-0': !_unref(isFieldValid)('phone_number', user.value) && form.value.processing,
        }])
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("account.phone_number_required_to_reset_password")), 1)
        ]),
        _createVNode(DbInput, {
          modelValue: user.value.phone_number,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((user.value.phone_number) = $event)),
          value: user.value.phone_number,
          class: _normalizeClass([{
            'border-red-500':
              !_unref(isFieldValid)('phone_number', user.value) && form.value.processing,
          }, "w-full hydrated"]),
          placeholder: _ctx.$t('account.phone_number'),
          label: _ctx.$t('account.phone_number'),
          ariainvalid: 
            !_unref(isFieldValid)('phone_number', user.value) && form.value.processing ? 'true' : ''
          
        }, null, 8, ["modelValue", "value", "class", "placeholder", "label", "ariainvalid"]),
        (!_unref(isFieldValid)('phone_number', user.value) && form.value.processing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.$t("account.validation.phone_number")), 1))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(DbButton, {
            class: "w-full",
            onClick: _cache[4] || (_cache[4] = () => _unref(router).push('/reset-password'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("account.password_reset")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(DbButton, {
            class: "w-full",
            onClick: _cache[5] || (_cache[5] = () => _unref(router).push('/')),
            variant: "secondary-solid"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("account.cancel")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(DbButton, {
            onClick: update,
            variant: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("account.save")), 1)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})